<script setup lang="ts">
import StickyFooter from "@/shared/components/StickyFooter.vue";
import { withPool } from "@/shared/utils/injection.ts";

const { savePool, isPoolDirty } = withPool();
</script>

<template>
  <StickyFooter v-if="isPoolDirty">
    <button
      class="lg:max-w-3xl lg:mx-auto btn--primary rounded-xl bigger-clickable-area w-1/2 lg:w-1/3 text-xs"
      @click="
        savePool().then(() => $router.replace(`/pool/${$route.params.poolId}`))
      "
    >
      {{ $t("Save") }}
    </button>
  </StickyFooter>
</template>
